import { createContext, useCallback, useContext } from 'react';
export const RoleViewContext = createContext('');
export function useRoleViewFetch() {
  const userId = useContext(RoleViewContext);
  return useCallback((url, options = {}) => {
    if (!userId) return window.fetch(url, options);
    const headers = new Headers(options.headers);
    if (userId) headers.set('X-Role-View-User', userId);
    return window.fetch(url, { ...options, headers });
  }, [userId]);
}
